import type { FmTableColumn } from '../../types/fm-table';
import type {
  FmDashboardExpertColumn,
  FmDashboardRankedCollectionSection,
  FmDashboardRankedRecord,
  FmDashboardScalar,
} from './FmDashboardOverview.types';

export function formatDashboardScalar(value: FmDashboardScalar, unit?: string): string | number {
  const formatted =
    value === null ? '—' : typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value;
  return unit && value !== null ? `${formatted} ${unit}` : formatted;
}

function expertValue(
  record: FmDashboardRankedRecord,
  column: FmDashboardExpertColumn,
): FmDashboardScalar {
  switch (column.value.field) {
    case 'rank':
      return record.rank;
    case 'title':
      return record.title;
    case 'state':
      return record.stateSentence;
    case 'reason':
      return record.reason;
    case 'change':
      return typeof record.changeSummary === 'string' ? record.changeSummary : null;
    case 'source':
      return record.evidence.sources[0].label;
    case 'revision':
      return record.evidence.sources[0].revision ?? null;
    case 'expert':
      return record.expertValues[column.value.key] ?? null;
  }
}

export function tableColumns(
  section: FmDashboardRankedCollectionSection,
): FmTableColumn<FmDashboardRankedRecord>[] {
  return section.expertTable.columns.map((column) => ({
    key: column.id,
    header: column.label,
    label: column.label,
    role: column.role,
    numeric: column.role === 'numeric' || column.role === 'money' || column.role === 'delta',
    render: (record) => formatDashboardScalar(expertValue(record, column)),
  }));
}
